var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Collapse, Flex, Heading } from 'shared/components/ui';
import { useTrackedDisclosure } from 'shared/features/analytics';
export var IconSide;
(function (IconSide) {
    IconSide[IconSide["Left"] = 0] = "Left";
    IconSide[IconSide["Right"] = 1] = "Right";
})(IconSide || (IconSide = {}));
/**
 *  A collapsible header component that will display a title and a button to toggle the visibility of the content
 */
export var CollapsibleHeader = function (_a) {
    var title = _a.title, openIcon = _a.openIcon, closeIcon = _a.closeIcon, children = _a.children, _b = _a.size, size = _b === void 0 ? 'h3' : _b, _c = _a.iconSide, iconSide = _c === void 0 ? IconSide.Left : _c, useDisclosureProps = _a.useDisclosureProps, props = __rest(_a, ["title", "openIcon", "closeIcon", "children", "size", "iconSide", "useDisclosureProps"]);
    var _d = useTrackedDisclosure(title, useDisclosureProps), isOpen = _d.isOpen, onToggle = _d.onToggle;
    /**
     * Render the component
     */
    return (_jsx(_Fragment, { children: _jsx(Flex, __assign({}, props, { children: _jsxs(Box, __assign({ w: "100%" }, { children: [_jsxs(Flex, __assign({ direction: "row" }, { children: [iconSide === IconSide.Left && (_jsx(Box, __assign({ onClick: onToggle, mt: 1, mr: 2 }, { children: isOpen ? closeIcon : openIcon }))), _jsx(Box, { children: _jsx(Heading, __assign({ size: size }, { children: title })) }), iconSide === IconSide.Right && (_jsx(Box, __assign({ onClick: onToggle, mt: 'auto', mb: 'auto', ml: 2 }, { children: isOpen ? closeIcon : openIcon })))] })), _jsx(Collapse, __assign({ in: isOpen }, { children: children }))] })) })) }));
};
